<template>

  <div class="grid">
    <loading :active="isLoadingModel" :can-cancel="true" color="#803BB9" :is-full-page="fullPage"></loading>
    <div class="col-12">
      <div class="card">
        <Toast />
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems">
          <template #item="{ item, props }">
            <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
              <a :href="href" @click="navigate">
                <span :class="[item.icon, 'text-color']" />
                <span class="text-primary font-semibold">{{ item.label }}</span>
              </a>
            </router-link>
          </template>
        </Breadcrumb>
      </div>

      <div class="card">       
        <div class="p-fluid formgrid grid" style="margin-top: 1% ; margin-bottom: 1%;">
          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <InputText type="text" format="number" v-model="search_title">
              </InputText>
              <label for="m_no">Title</label>
            </span>
          </div>
          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <Dropdown id="status" v-model="search_status" :options="status_dropdown" :value="status_dropdown"
                optionLabel="name" filter></Dropdown>
              <label for="status">Status</label>
            </span>
          </div>

          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <Dropdown id="status" v-model="search_hoarding" :options="hoarding_dropdownItems"
                :value="hoarding_dropdownItems" optionLabel="name" filter></Dropdown>
              <label for="status">Hoarding</label>
            </span>
          </div>

          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <Dropdown id="status" v-model="search_user" :options="user_dropdownItems" :value="user_dropdownItems"
                optionLabel="name" filter></Dropdown>
              <label for="status">User</label>
            </span>
          </div>

          <div class="field col-12 md:col-2">
            <Button icon="pi pi-search" @click="search(1)" v-tooltip.bottom="'Search'" /> &nbsp;
            <Button icon="pi pi-refresh" @click="search(2)" v-tooltip.bottom="'Reset'" class="mr-2" />
          </div>
        </div>
        <DataTable :loading="loading" ref="dt" size="small" :lazy="true" :totalRecords="totalRecords" :paginator="true"
          :value="products" v-model:selection="selectedProducts" :dataKey="columns[0]" :rows="limit" :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25, totalRecords]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" responsiveLayout="scroll"
          showGridlines :rowHover="true">
          <template #empty>
            <b style="text-align: center">No records found.</b>
          </template>
          <template #header>
            <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
              <h5 class="m-0"><b>Hoarding Notifiaction List</b></h5>
              <div>
                <Button icon="pi pi-plus" @click="openNew()" v-tooltip.bottom="'Add'" class="mr-2" />
                <Button icon="pi pi-download" @click="exportCSV($event)" v-tooltip.bottom="'Download'" class="mr-2 p-button-help" />
                <br>
                <p>Total : {{ totalRecords }}</p>
              </div>
            </div>
          </template>
          <Column header="Sr. No." style="min-width: 2rem; text-align: center">
            <template #body="{ index }">
              <span v-if="page_no == 1">{{ +index + +1 }}</span>
              <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
            </template>
          </Column>
          <Column header="Status" style="min-width: 3rem" :field="columns[0]">
            <template #body="{ data }">
              <span v-if="data.status == 'Active' || data.status == 'active'">
                <badge :value=data.status severity="success"></badge>
              </span>
              <span v-else-if="data.status == 'InActive' || data.status == 'Inactive'">
                <badge :value=data.status severity="warning"></badge>
              </span>
              <span v-else-if="data.status == 'Deleted' || data.status == 'deleted'">
                <badge :value=data.status severity="danger"></badge>
              </span>
              <span v-else>-</span>
            </template>
          </Column>

          <!-- <Column header="Notification No" style="min-width: 3rem" :field="columns[0]">
            <template #body="{ data }">
              {{ data.notification_id }}
            </template>
          </Column> -->
          <Column header="Notification Title" style="min-width: 3rem" :field="columns[0]">
            <template #body="{ data }">
              {{ data.notification_title }}
            </template>
          </Column>

          <Column header="Hoarding Name" style="min-width: 3rem" :field="columns[0]">
            <template #body="{ data }">
              {{ data.HoardingName }}
            </template>
          </Column>

          <Column header="User Name" style="min-width: 3rem" :field="columns[0]">
            <template #body="{ data }">
              {{ data.UserName }}
            </template>
          </Column>

          <Column header="Notification Date" style="min-width: 3rem" :field="columns[0]">
            <template #body="{ data }">
              {{ dateFormatDMY(data.notification_date) }}
            </template>
          </Column>

          <Column header="Notification Desc" style="min-width: 3rem" :field="columns[0]">
            <template #body="{ data }">
              {{ data.notification_description }}
            </template>
          </Column>

          <Column header="Action" headerStyle="min-width:13rem;">
            <template #body="slotProps">
              <Button icon="pi pi-pencil" title="Edit Client" v-tooltip.bottom="'Edit'"
                class="p-button-rounded p-button-warning mr-2" @click="editProduct(slotProps.data)" />
              <Button icon="pi pi-trash" v-tooltip.bottom="'Delete'" class="p-button-rounded p-button-danger mr-2"
                @click="confirmDeleteProduct(slotProps.data)" />
              <!-- <Button icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                @click="viewProduct(slotProps.data)" /> -->
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>

  <!-- Add Notification Dialog Box start -->
  <Sidebar v-model:visible="productDialog1" :baseZIndex="1000" position="full" @hide="onHide()">
    <div class="col-12">
      <div class="card">
        <h5 v-if="product._id">Update Song Form</h5>
        <h5 v-else>Add Song Form</h5>
        <hr />
        <div class="p-fluid formgrid grid">
          <div class="p-field col-12 md:col-4">
            <label for="name">Song Name</label>
            <InputText id="name" class="label-gap" v-model="product.song_name" />
          </div>

          <div class="p-field col-12 md:col-4">
            <label for="singer">Singer</label>
            <InputText id="singer" class="label-gap" v-model="product.singer" />
          </div>
          <div class="p-field col-12 md:col-4">
            <label for="music_composer">Music Composer</label>
            <InputText id="music_composer" class="label-gap" v-model="product.composer" />
          </div>
          <div class="p-field col-12 md:col-4">
            <label for="lyrics_writer" class="label-gap">Lyrics Writer</label>
            <InputText id="lyrics_writer" v-model="product.lyrics_writer" />
          </div>
          <div class="p-field col-12 md:col-4">
            <label for="duration" class="label-gap">Duration(min)</label>
            <InputText id="duration" v-model="product.duration" disabled />
          </div>
          <div class="p-field col-12 md:col-4">
            <label for="date">Date</label>
            <Calendar id="date" class="label-gap" v-model="product.date" showIcon />
          </div>


        </div>
        <hr />
      </div>
    </div>

    <div class="col-12 md:col-6">
      <Button style="background-color: white; border: 1px solid #349CE4; color: #349CE4;" v-if="product.notification_id"
        label="UPDATE" icon="pi pi-check" class="p-button-success mr-1 mb-1" @click="adduser" />
      <Button style="background-color: white; border: 1px solid #349CE4; color: #349CE4;" v-else label="ADD"
        icon="pi pi-check" class="p-button-success mr-1 mb-1" @click="adduser" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <Button style="background-color: #349CE4;" label="Cancel" icon="pi pi-times" class="p-button-primary mr-1 mb-1"
        @click="onHide()" />
    </div>
  </Sidebar>
  <!--  -->
  <Dialog v-model:visible="productDialog" :style="{ width: '1000px' }" header="Form" @hide="onHide()">
    <div class="col-12">
      <div class="card">
        <h5 v-if="product._id">Update Notification</h5>
        <h5 v-else>Add Notification</h5>
        <hr />
        <div class="p-fluid formgrid grid">
          <div class="p-field col-12 md:col-6">
            <label for="name">Notification Title</label>
            <InputText id="name" class="label-gap" v-model="product.notification_title" />
          </div>

          <div class="p-field col-12 md:col-6">
            <label for="singer">Notification Description</label>
            <InputText id="singer" class="label-gap" v-model="product.notification_description" />
          </div>

          <div class="p-field col-12 md:col-6">
            <label for="date">Notification Date</label>
            <Calendar id="date" class="label-gap" v-model="product.notification_date" showIcon />
          </div>

          <div class="p-field col-12 md:col-6">
            <label for="status">Status</label>
            <Dropdown id="status" v-model="notification_status" :options="status_dropdown" :value="status_dropdown"
              optionLabel="name" filter></Dropdown>
          </div>

          <div class="p-field col-12 md:col-6">
            <label for="album_name" class="p-inputgroup label-button-group">Hoarding Name</label>
            <Dropdown class="label-gap" id="status" v-model="hoarding_dropdownItem" :options="hoarding_dropdownItems"
              :value="hoarding_dropdownItems.value" optionLabel="name" filter>
            </Dropdown>
          </div>

          <!-- <div class="p-field col-12 md:col-6">
            <label for="album_name" class="p-inputgroup label-button-group">User Name {{ user_dropdownItem }}</label>
            <Dropdown class="label-gap" id="status" v-model="user_dropdownItem" :options="user_dropdownItems"
              :value="user_dropdownItems.value" optionLabel="name" filter>
            </Dropdown>
          </div> -->

        </div>
        <hr />
      </div>
    </div>

    <div class="col-12 md:col-6">
      <Button v-if="product.notification_id" label="UPDATE" icon="pi pi-check" class="p-button-success mr-1 mb-1"
        @click="adduser" />
      <Button v-else label="ADD" icon="pi pi-check" class="p-button-success mr-1 mb-1"
        @click="adduser" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <Button label="Cancel" icon="pi pi-times" class="p-button-primary mr-1 mb-1" @click="onHide()" />
    </div>
  </Dialog>
  <!-- Add Notification Dialog Box end -->

  <!--  -->
  <Dialog v-model:visible="deleteProductDialog" :style="{ width: '450px' }" header="Confirm" :modal="true">
    <div class="flex align-items-center justify-content-center">
      <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
      <span v-if="product">Are you sure you want to delete <b>{{ product.name }}</b>?</span>
    </div>
    <template #footer>
      <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteProductDialog = false" />
      <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deletegroup" />
    </template>
  </Dialog>
  <!--  -->

</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import apis from "@/apis";
import axios from "axios";
import BreadcrumbService from "../service/BreadcrumbService";
import { GoogleMap, Marker, MarkerCluster, InfoWindow, GMapMarker, Polyline } from "vue3-google-map";
export default {
  data() {
    return {
      center: { lat: 19.0626704, lng: 73.005094 },
      hoarding_dropdownItems: [],
      hoarding_dropdownItem: { name: "", value: "" },
      user_dropdownItems: [],
      user_dropdownItem: { name: "", value: "" },
      search_title: "",
      search_status: "",
      search_hoarding: "",
      search_user: "",
      // notification_status: "",
      notification_status: { name: "", value: "" },
      status_dropdown: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],
      breadcrumbHome: {},
      breadcrumbItems: [],
      BreadcrumbService: null,

      page_no: 1,
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      file_attachment: "",
      products: null,
      productDialog: false,
      deleteProductDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      limit: 10,
      columns: [],
      pageno: 1,
      submitted: false,
      totalRecords: 0,
      id: "",
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    this.BreadcrumbService = new BreadcrumbService();
    let Breadcrum_data = this.BreadcrumbService.getBreadcrum("Notifiaction", "/notificationlist")
    this.breadcrumbHome = Breadcrum_data.home;
    this.breadcrumbItems = Breadcrum_data.items;
    this.get_hoarding_dropdown();
    this.get_user_dropdown();
  },
  async mounted() {
    // this.productService.getProducts().then(data => this.products = data);
    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
    //alert(this.id);
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        // await this.get_count();
        // this.get_list();
      }
    },
  },
  methods: {
    get_hoarding_dropdown() {
      this.hoarding_dropdownItems = [];
      var data = {};
      this.loading = true;
      var promise = apis.HoardingDropdownList(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].HoardingName,
              value: response.data.data[x].id,
            });
          }
          this.hoarding_dropdownItem = { name: "", value: "" };
          this.hoarding_dropdownItems = temp_data;
          // console.log("hoarding data--", this.hoarding_dropdownItems);
        }
      });
    },

    get_user_dropdown() {
      this.user_dropdownItems = [];
      var data = {};
      this.loading = true;
      var promise = apis.UserDropdownList(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].UserName,
              value: response.data.data[x].UserID,
            });
          }
          this.user_dropdownItem = { name: "", value: "" };
          this.user_dropdownItems = temp_data;
          // console.log("user data--", this.user_dropdownItems);
        }
      });
    },

    deletegroup() {
      if (this.product.notification_id) {
        var data = {
          notification_id: this.product.notification_id,
        };
        this.isLoadingModel = true;
        var promise = apis.deleteNotification(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            this.deleteProductDialog = false;
            this.$swal(responseapi.data.message);
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Record");
          }
        });
      }
    },
    onHide() {
      this.product = {};
      this.notification_status = { name: "", value: "" };
      this.hoarding_dropdownItem = { name: "", value: "" };
      this.user_dropdownItem = { name: "", value: "" };

      this.productDialog = false;
    },
    async search(count) {
      if (count == 2) {
        this.search_status = "";
        this.search_hoarding = "";
        this.search_user = "";
        this.search_title = "";
      }

      await this.get_list();
      await this.get_count();
    },
    async adduser() {
      this.submitted = true;
      if (!this.product.notification_title) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Notification name",
          life: 3000,
        });
        return false;
      }

      // if (!this.product.notification_description) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Enter Notification Desciption",
      //     life: 3000,
      //   });
      //   return false;
      // }

      if (!this.product.notification_date) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Notification Date",
          life: 3000,
        });
        return false;
      }

      if (!this.notification_status.value) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Status",
          life: 3000,
        });
        return false;
      }

      if (!this.hoarding_dropdownItem.value) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Hoarding",
          life: 3000,
        });
        return false;
      }

      // if (!this.user_dropdownItem.value) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Select USer",
      //     life: 3000,
      //   });
      //   return false;
      // }

      var status = '';
      if (this.notification_status) {
        status = this.notification_status.value;
      }

      var hoarding_id = '';
      if (this.hoarding_dropdownItem) {
        hoarding_id = this.hoarding_dropdownItem.value;
      }

      // var user_id = '';
      // if (this.user_dropdownItem) {
      //   user_id = this.user_dropdownItem.value;
      // }


      //edit
      if (this.product.notification_id) {
        var data = {
          "notification_id": this.product.notification_id,
          "status": status,
          "notification_title": this.product.notification_title,
          "notification_description": this.product.notification_description,
          "notification_date": this.product.notification_date,
          "hoarding_id": hoarding_id,
          "user_id": this.product.user_id,
          "updated_by": localStorage.getItem("id"),
        };
        // console.log(data);
        // return false;
        this.isLoadingModel = true;
        var promise = apis.editNotification(data);
        promise
          .then((response) => {
            this.isLoadingModel = false;
            if (response.data.status == true) {
              this.productDialog = false;
              this.$swal(response.data.message);
              this.get_list();
              this.get_count();
            } else {
              this.$swal(response.data.message);
            }
          })
          .catch((error) => {
            //console.log(error);
            // alert("edited");
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal.fire(error.response.data.error);
            this.get_list();
            this.get_count();
          });
      }
      //add-----------------------------------------------------------------------------------------------------------------
      else {
        // alert("add");
        var data1 = {
          "notification_title": this.product.notification_title,
          "notification_description": this.product.notification_description,
          "notification_date": this.dateFormatDMY(this.product.notification_date),
          "status": status,
          "hoarding_id": hoarding_id,
          "created_by": localStorage.getItem("id")
        };
        // console.log(data1);
        // return false;
        this.isLoadingModel = true;
        var promises = apis.addNotification(data1);
        promises
          .then((response) => {
            this.isLoadingModel = false;
            if (response.data.status == true) {
              this.productDialog = false;
              this.$swal(response.data.message);
              this.get_list();
              this.get_count();
            } else {
              this.$swal(response.data.message);
            }

          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal.fire(error.response.data.error);
            this.get_list();
            this.get_count();
          });
      }

    },
    dateFormatYMD(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == 'NaN-NaN-NaN') {
          return postdate;

        }
        else {
          let date = ("0" + inputDate.getDate()).slice(-2);

          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == 'aN') {
            return postdate;
          }
          else {
            return year + "-" + month + "-" + date;
          }
        }
      }
      else {
        return "";
      }
    },
    dateFormatDMY(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == 'NaN-NaN-NaN') {
          return postdate;

        }
        else {
          let date = ("0" + inputDate.getDate()).slice(-2);

          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == 'aN') {
            return postdate;
          }
          else {
            return date + "-" + month + "-" + year;
          }
        }
      }
      else {
        return "";
      }
    },
    //a simple date formatting function
    dateFormat(inputDate, info) { },
    handleFileUpload() {
      this.file_attachment = this.$refs.file_attachment.files[0];
      //alert(this.$refs.file_attachment.files[0].name);
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // console.log(event);
      // await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var status = '';
      if (this.search_status) {
        status = this.search_status.value;
      }

      var hoarding_id = '';
      if (this.search_hoarding) {
        hoarding_id = this.search_hoarding.value;
      }

      var user_id = '';
      if (this.search_user) {
        user_id = this.search_user.value;
      }

      var data = {
        count: true,
        notification_title: this.search_title,
        status: status,
        hoarding_id: hoarding_id,
        user_id: user_id,

      };
      this.loading = true;
      var promise = apis.notificationList(data, this.id);
      promise.then((response) => {
        this.loading = false;
        // console.log(response);
        this.totalRecords = response.data.total;
        //alert(this.totalRecords);
      });
      // console.log(data);
    },
    get_list: function () {
      var status = '';
      if (this.search_status) {
        status = this.search_status.value;
      }

      var hoarding_id = '';
      if (this.search_hoarding) {
        hoarding_id = this.search_hoarding.value;
      }

      var user_id = '';
      if (this.search_user) {
        user_id = this.search_user.value;
      }

      var data = {
        page_no: this.page_no,
        Limit: this.limit,
        count: false,
        notification_title: this.search_title,
        status: status,
        hoarding_id: hoarding_id,
        user_id: user_id,

      };
      this.loading = true;
      var promise = apis.notificationList(data, this.id);
      promise.then((response) => {
        this.loading = false;
        // console.log(response);
        this.products = response.data.data;
        // console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
      // console.log(data);
    },
    formatCurrency(value) {
      if (value)
        return value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
      return;
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    saveProduct() {
      this.submitted = true;
      if (this.product.id) {
        //
      } else {
        //
      }
      this.productDialog = false;
      this.product = {};
    },
    editProduct(product) {
      // this.file_attachment = "";
      this.product = { ...product };
      this.notification_status.value = this.product.status;
      this.notification_status.name = this.product.status;

      // this.user_dropdownItem.value = this.product.user_id;
      // this.user_dropdownItem.name = this.product.user_id;

      this.hoarding_dropdownItem.value = this.product.hoarding_id;
      this.hoarding_dropdownItem.name = this.product.hoarding_id;

      // console.log("edit data:-", this.product);
      this.productDialog = true;
    },
    async viewProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  // components: {},
  components: {GoogleMap, Marker, MarkerCluster, InfoWindow, GMapMarker, Polyline},
};
</script>
<style scoped lang="scss">
.label-gap {
  margin-bottom: 0.8rem;
}

@import "../assets/demo/badges.scss";
</style>
